export default [
  {
    title: "Bienvenido al sistema",
    color: "light-green",
    icon: "account_circle",
    timeLabel: "Hace un momento",
  },
  { divider: true, inset: true },
  {
    title: "Nuevo pedido",
    color: "light-blue",
    icon: "shopping_cart",
    timeLabel: "Hace 2 minutos",
  },
];
